import ManageTermsPolicyAndContact from './manageTermsPolicyAndContact';

export default ManageTermsPolicyAndContact;



// WEBPACK FOOTER //
// ./src/app/views/admin/manageTermsPolicies/index.js